import PropTypes from 'prop-types';
import { D1, D2, D3 } from '../utils/dash';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var HoursDash = function HoursDash(_ref) {
  var x = _ref.x,
      label = _ref.label,
      vertical = _ref.vertical,
      height = _ref.height;
  return /*#__PURE__*/_jsxs("g", {
    className: 'ptr-timeline-hour',
    children: [height === 1 ? /*#__PURE__*/_jsx(D1, {
      x: x,
      vertical: vertical
    }) : null, height === 2 ? /*#__PURE__*/_jsx(D2, {
      x: x,
      vertical: vertical
    }) : null, height === 3 ? /*#__PURE__*/_jsx(D3, {
      x: x,
      vertical: vertical
    }) : null, label]
  });
};

HoursDash.propTypes = {
  x: PropTypes.number.isRequired,
  label: PropTypes.element,
  vertical: PropTypes.bool,
  height: PropTypes.number
};
HoursDash.defaultProps = {
  vertical: false,
  label: null
};
export default HoursDash;